// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3LNrm","buttons":"PendingPaymentAlert_buttons__1H0Ew"};